import React, { useState } from 'react'
import {
	Collapse,
	COLORS,
	CurrencyDisplay,
	H2Flow,
} from '@monthio/react-components'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { FrequencyChip } from './FrequencyChip'
import { getExpenseEstimateTitle } from '../getExpenseEstimateTitle'
import { ItemWithOptionalLogo } from '../../../../modulesTemp/shared/ItemWithOptionalLogo'
import { ExpenseEstimateDto, PaymentFrequency } from '#modules/Budget/types/expense.types'
import { ExpandIcon } from '../../../../modulesTemp/shared/ExpandIcon'
import { TransactionsTable } from '#modules/Budget/Components/BudgetOverview/BudgetCategorizedTransactionsTable/TransactionsTable'

export const TransactionsTableWrapper = styled.div`
	background: ${COLORS.GREY_SCALE.WHITE};
	padding: 0 16px;
	border-radius: 4px;
`

const FrequencyAndAmountWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	align-items: end;
`
const StyledH2Flow = styled(H2Flow)`
	margin: 0;
`
type ExpenseEstimateProps = {
	expenseEstimate: ExpenseEstimateDto
}

export const ExpenseEstimate: React.FC<ExpenseEstimateProps> = ({
	expenseEstimate,
}) => {
	const { t } = useTranslation()
	const [expanded, setExpanded] = useState(false)

	const { underlyingChain, paymentSchedule, monthlyAmount } = expenseEstimate

	const title = getExpenseEstimateTitle(expenseEstimate)

	const occurrence = underlyingChain?.transactions.length
	const occurrenceText = occurrence
		? `${occurrence} ${t('assetExpenses-expenseEstimate-occurrence', {
				count: occurrence,
			})}`
		: ''

	const displayExpandIcon = !!underlyingChain?.transactions?.length

	return (
		<div>
			<ItemWithOptionalLogo
				title={title}
				description={occurrenceText}
				isRounded
				hasBorder
				onClick={() => setExpanded(!expanded)}
			>
				<FrequencyAndAmountWrapper>
					<FrequencyChip
						frequency={
							paymentSchedule?.frequency ?? PaymentFrequency.EveryMonth
						}
					/>
					<StyledH2Flow>
						<CurrencyDisplay
							amount={Math.abs(paymentSchedule?.amount ?? monthlyAmount)}
						/>
					</StyledH2Flow>
				</FrequencyAndAmountWrapper>
				{displayExpandIcon ? (
					<ExpandIcon expanded={expanded} color={COLORS.TEXT_COLORS.DEFAULT} />
				) : null}
			</ItemWithOptionalLogo>
			<Collapse in={expanded} timeout="auto">
				<TransactionsTableWrapper>
					<TransactionsTable
						transactions={underlyingChain?.transactions}
						columnWidths={['20%', '40%', '40%']}
					/>
				</TransactionsTableWrapper>
			</Collapse>
		</div>
	)
}
